import { render, staticRenderFns } from "./WaterSourceChip.vue?vue&type=template&id=00ef97f4&"
import script from "./WaterSourceChip.vue?vue&type=script&lang=js&"
export * from "./WaterSourceChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports